// extracted by mini-css-extract-plugin
export default {"breadcrumb":"uj-z","breadcrumbItem":"vj-z","hideOnMobile":"wj-z"};